import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const theme_beta = {
    palette: {
        primary: {
            main: '#3c3c3c',
        },
        secondary: {
            main: '#8fa2b2',
        },
        customLight: {
            main: '#eaeaea',
        },
        background: {
            paper: '#5b5b5b',
        },
        customCard: {
            main: '#b7b7b7',
        },
        customText: {
            dark: '#505050',
            main: '#757575',
            blue: '#4FC3F7',
            yellow: '#FFF176',
            orange: '#FFB74D',
            redOrange: '#FF5349',
            white: '#eaeaea',
            lightGrey: '#BDBDBD',
            lightGrey2: '#E0E0E0'
        }
    },
    typography: {
        fontFamily: [
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
        h1: {
            fontWeight: 'bold',
        },
        h2: {
            fontWeight: 'bold',
        },
        h3: {
            fontWeight: 'bold',
        },
        h4: {
            fontWeight: 'medium',
        },
        h5: {
            fontWeight: 'medium',
        },
        h6: {
            fontWeight: 'medium',
        },
        coverAnimatedTextXS: {
            fontWeight: 'bold',
            fontSize: '1.1rem',
        },
        body1: {
            fontWeight: 400,
        },
        bodyWhoAmI: {
            fontWeight: 400,
            fontSize: '1.3rem',
        },
        personalInfoItemKey: {
            fontWeight: 'bold',
            fontSize: '1.3rem',
        },
        personalInfoItemValue: {
            fontWeight: 400,
            fontSize: '1.3rem',
        },
        cardHeaderTitle: {
            fontSize: '1.8rem',
            fontWeight: 'bold',
        },
        cardContentTitle: {
            fontWeight: 'bold',
            fontSize: '1.6rem'
        },
        cardContentDesc: {
            fontWeight: 'medium',
            fontSize: '1.2rem'
        }
      },
}


let theme = createTheme(theme_beta);
theme = responsiveFontSizes(theme);
export { theme };